module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/cabecera.jpg
// module id = r2Oj
// module chunks = 0